const WARRANTY_DEFINITIONS = [
    { key: "leakageWarranty", label: "Leakage Warranty" },
    { key: "acpWarranty", label: "ACP Warranty" },
    { key: "aluminiumCBondWarranty", label: "Aluminium C-Bond Warranty" },
    { key: "glassWarranty", label: "Glass Awning" },
    { key: "polycarbonateWarranty", label: "Polycarbonate Warranty" },
    { key: "metaldeckWarranty", label: "Metal Deck Warranty" },
    { key: "structureWarranty", label: "Structure Warranty" },
];

const formatWarrantyText = (years, label) => {
    const yearLabel = years === 1 ? "1 Year" : `${years} Years`;
    return `Free ${yearLabel} ${label}`;
};

/** Warranty lines from order.warranty fields (matches ihgroup-api/utils/buildOrderWarranties.js). */
export const buildOrderWarranties = (order) => {
    const warranty = order?.warranty || {};
    const warranties = [];

    WARRANTY_DEFINITIONS.forEach(({ key, label }) => {
        const years = Number(warranty[key]);
        if (!Number.isFinite(years) || years <= 0) return;
        warranties.push({
            years,
            text: formatWarrantyText(years, label),
        });
    });

    warranties.sort((a, b) => a.years - b.years);
    return warranties;
};

export const buildOrderWarrantyTexts = (order) =>
    buildOrderWarranties(order).map((w) => w.text);

export const WARRANTY_FIELD_KEYS = WARRANTY_DEFINITIONS.map((def) => def.key);

export const hasAnyWarrantyValue = (warranty = {}) =>
    WARRANTY_FIELD_KEYS.some((key) => warranty[key] != null);

export const buildWarrantyPayload = (warranty = {}) => {
    if (!hasAnyWarrantyValue(warranty)) return undefined;
    return WARRANTY_FIELD_KEYS.reduce((payload, key) => {
        if (warranty[key] != null) {
            payload[key] = warranty[key];
        }
        return payload;
    }, {});
};
